import { BiSupport } from 'react-icons/bi';
import css from './Support.module.css';
import { useState } from 'react';
import Modal from '../Modals/Modal/Modal.jsx';
import SupportModal from '../Modals/SupportModal/SupportModal.jsx';
import useTooltip from '../../utils/useTooltip.jsx';
import Tooltip from '../sharedComponents/Tooltip/Tooltip.jsx';

export default function Support() {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsTooltipVisible(false);
    setIsOpen(true);
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const {
    tooltipPosition,
    isTooltipVisible,
    setIsTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useTooltip({ x: -50, y: 25 });

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <button className={css.btn} onClick={openModal}>
        <BiSupport className={css.icon} />
      </button>
      {modalIsOpen && (
        <Modal isOpen={modalIsOpen} onClose={handleModalClose}>
          <SupportModal onClose={handleModalClose} />
        </Modal>
      )}

      {isTooltipVisible && !modalIsOpen && (
        <Tooltip
          isVisible={isTooltipVisible}
          position={tooltipPosition}
          text="Підтримка"
        />
      )}
    </div>
  );
}
